/*import React,{useState} from "react";
import { Container,Row,Col} from "react-bootstrap";
import ProductOverlay from "./ourProducts";
import Button from "react-bootstrap/Button";
import Card from 'react-bootstrap/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone ,faMapMarker} from '@fortawesome/free-solid-svg-icons';
import Footer from "./footer";
import "./contactus.css";

const ContactUs= () =>{
    const [isHovered, setIsHovered] = useState(false);
    return(
        <Container fluid style={{padding: "0px 0px" , marginBottom: "0px" , backgroundColor:"rgb(240,240,240)"}}>
            <ProductOverlay heading="Contact Us"/>
            <Row>
                <Col>
                <div>
                    <Button variant="outline-secondary" style={{marginLeft: "50px",marginTop: "100px",display: 'flex', justifyContent: 'flex-start'}}>Contact Us</Button>
                </div>
                <h1 style={{textAlign: "left", paddingLeft: "50px",marginTop: "20px"}}>Contact Information</h1>
                </Col>
                <Col>
                    <h5 style={{ paddingLeft: "50px",marginRight: "30px", marginTop: "100px"}}> Feel free to reach out for questions, assistance, or collaboration opportunities.</h5>
                    <h5 style={{ alignItems:"left", paddingLeft: "50px",marginRight: "30px"}}>We are here to help you.</h5>
                </Col>
            </Row>
            <Row fluid style={{
                                padding: "50px 50px",
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '50vh',
                                marginBottom: "100px"

                            }}
            >
                    <Card style={{ width: '28rem' ,
                        backgroundColor: isHovered ? '#f0f0f0' : 'white',
                        transition: 'background-color 0.3s ease',
                        padding: "20px 20px"
                    }}
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                    >
                    <Card.Body>
                        <Card.Title style={{marginTop: "20px",fontSize:"20px"}}>Lucknow Office</Card.Title>
                        <Card.Text>
                            <FontAwesomeIcon icon={faPhone} style={{ marginRight: '5px' ,marginTop: "30px"}} />
                            +919278077911
                        </Card.Text>
                        <Card.Text>
                            <FontAwesomeIcon icon={faEnvelope} style={{ marginRight: '5px' }} />
                            asavapharma@gmail.com
                        </Card.Text>
                        <Card.Text style={{marginBottom:"30px"}}>
                            <FontAwesomeIcon icon={faMapMarker} style={{ marginRight: '5px' }} />
                                    H.No - 19, Kh.No - 367/1,
                                    Nijampur Malhaur Chinhat,
                                    Secretariat, Lucknow,
                                    Uttar Pradesh,India,
                                    226001
                        </Card.Text>
                    </Card.Body>
                </Card>
            </Row>
            <Row style={{backgroundColor:"rgb(208,208,208)"}}>
                <Footer/>
            </Row>
        </Container>
    ) 
}
export default ContactUs;*/



import React from "react";
import { Helmet } from 'react-helmet-async';
import { Container, Row } from "react-bootstrap";
import ProductOverlay from "./ourProducts";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import Footer from "./footer";
import "./contactus.css";

const ContactUs = () => {
    return (
        <Container fluid className="contact-page">
            <Helmet>
                <title>Contact Us | Asava Pharmaceutical Pvt Ltd — Lucknow, Uttar Pradesh</title>
                <meta name="description" content="Contact Asava Pharmaceuticals — pharma company in Lucknow, UP. Enquire about medicines, bulk orders, pharma distribution in Basti, Gorakhpur, Varanasi or any district of Uttar Pradesh, India." />
                <link rel="canonical" href="https://www.asavapharma.in/contactinfo" />
            </Helmet>
            <ProductOverlay heading="Contact Us" />

            {/* ── Hero ── */}
            <div className="contact-hero">
                <div className="contact-hero-left">
                    <div className="contact-eyebrow">Reach Out</div>
                    <h1 className="contact-heading">
                        Contact <br /><span>Information</span>
                    </h1>
                </div>
                <div className="contact-hero-right">
                    <p className="contact-subtext">
                        Feel free to reach out for questions, assistance,
                        or collaboration opportunities.
                    </p>
                    <p className="contact-subtext">
                        We are here to help you.
                    </p>
                </div>
            </div>

            {/* ── Card ── */}
            <div className="contact-cards-section">
                <div className="contact-card">
                    <div className="contact-card-header">
                        <div className="contact-card-title">Lucknow Office</div>
                        <div className="contact-card-subtitle">Uttar Pradesh · India</div>
                    </div>

                    <div className="contact-card-body">
                        <div className="contact-info-row">
                            <div className="contact-icon-wrap">
                                <FontAwesomeIcon icon={faPhone} className="contact-icon" />
                            </div>
                            <div>
                                <p className="contact-info-label">Phone</p>
                                <p className="contact-info-value">+91 92780 77911</p>
                            </div>
                        </div>

                        <div className="contact-info-row">
                            <div className="contact-icon-wrap">
                                <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
                            </div>
                            <div>
                                <p className="contact-info-label">Email</p>
                                <p className="contact-info-value">asavapharma@gmail.com</p>
                            </div>
                        </div>

                        <div className="contact-info-row">
                            <div className="contact-icon-wrap">
                                <FontAwesomeIcon icon={faMapMarkerAlt} className="contact-icon" />
                            </div>
                            <div>
                                <p className="contact-info-label">Address</p>
                                <p className="contact-info-value">
                                    H.No - 19, Kh.No - 367/1<br />
                                    Nijampur Malhaur Chinhat<br />
                                    Secretariat, Lucknow<br />
                                    Uttar Pradesh, India — 226001
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Row className="contact-footer-row">
                <Footer />
            </Row>
        </Container>
    );
};

export default ContactUs;